<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Product Sync List
        </h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
        </div>
      </div>
    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">
        No product found!
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="table-responsive">
              <table
                class="dataTable table table-striped no-footer nowrap"
                style="width: 100%;"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <td>SKU</td>
                    <td>Name</td>
                    <td>Store ID</td>
                    <th>User ID</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) in list"
                    :class="index % 2 == 0 ? 'odd' : 'even'"
                    :key="product.id"
                  >
                    <td>
                      #{{product.id}}
                    </td>
                    <td>
                      {{ product.sku }}
                    </td>
                    <td>
                      {{ product.name }}
                    </td>
                    <td>
                      <router-link
                        :to="{ name: 'storeDetail', params: { storeId: product.storeId }}"
                      >
                        #{{ product.storeId }}
                      </router-link>
                    </td>
                    <td>
                      <router-link
                        :to="{ name: 'userDetail', params: { userId: product.userId }}"
                      >
                        #{{ product.userId }}
                      </router-link>
                    </td>
                    <td class="text-right">
                      <form-button
                        type="danger"
                        :classes="['ml-2']"
                        :click="() => removeProductSync(product.id)"
                        :loading="product.loading"
                        :disabled="product.loading"
                      >
                        <i class="fa fa-trash" />
                      </form-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <pagination
            :route-name="routeName"
            :query="search"
            :current="page"
            :total="total"
          />
        </div>
      </div>
    </loading-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import _ from 'lodash';

import LoadingContainer from "@/components/Misc/LoadingContainer";
import Pagination from "@/components/Misc/Pagination";
import LinkButton from "@/components/Misc/LinkButton";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Uuid from "@/components/Common/Uuid";
import FormButton from "@/components/Form/FormButton";

export default {
  name: "ProductSyncList",
  components: {
    LoadingContainer,
    Pagination,
    Breadcrumb,
    Uuid,
    LinkButton,
    FormButton,
  },
  beforeMount() {
    const query = this.$route.query;
    const page = query.page || 1;
    const sku = query.sku;
    this.getList({
      page,
      search: { sku },
    });
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      list: "productSync/list",
      loading: "productSync/loading",
      search: "productSync/search",
      count: "productSync/count",
      total: "productSync/total",
      page: "productSync/page",
    }),
    routeName() {
      return this.$router.name;
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
  },
  methods: {
    ...mapActions({
      getList: "productSync/getList",
      removeProductSync: "productSync/removeProductSync",
    }),
  },
};
</script>

<style scoped>
</style>
